export default __webpack_public_path__ + "static/montagne2-87f27eaffa3ab27563fade738a16d716.svg";